import { FilterIcon, FilterWhiteIcon } from 'assets/svg';
import { memo, useRef, useState } from 'react';
import Button from './Button';

interface IProps {
  setIsOpen: any;
  isOpen: boolean;
  disabled?: boolean;
}

const ButtonFilter = memo(({ isOpen, setIsOpen, disabled }: IProps) => {
  const [isHover, setIsHover] = useState(false);

  const handleMouseEnter = () => {
    setIsHover(true);
  };

  const handleMouseLeave = () => {
    setIsHover(false);
  };

  return (
    <Button
      fill={isOpen}
      customClass="px-3"
      title={isOpen || isHover ? <FilterWhiteIcon /> : <FilterIcon />}
      disabled={disabled}
      handleOnclick={() => setIsOpen((prev: boolean) => !prev)}
      handleOnMouseEnter={handleMouseEnter}
      handleOnMouseLeave={handleMouseLeave}
    />
  );
});

export default ButtonFilter;
